import React, { useState, useEffect } from "react";
import { Card, CardTitle, Row, Col,Button } from "reactstrap";
import ReactTable from "react-table";
import { connect } from 'react-redux';
import BackButton from "../../../../designUtils/Logo/BackButton.svg";
import FetchAmazonNotificationLogsService from "../../../../Service/DashboardServices/AmazonNotificationsServices/FetchAmazonNotificationLogsService";
import GridPagination from "../../../Components/Pagination/GridPagination";
import LoadingOverlay from "react-loading-overlay";
import Loader from "react-loaders";
import NotificationPayload from "./Components/NotificationPayload";
import NotificationsSubscriptionsTypes from "./Components/NotificationsSubscriptionsTypes";
import CustomModal from "../../../Components/Modals/CustomModal";

function AmazonNotificationsMainPage(props) {

    const [isLoading, setIsLoading] = useState(false);
    const [notificationData, setNotificationData] = useState([]);
    const [search, setSearch] = useState("");
    const [currentPage, setCurrentPage] = useState(0);
    const [totalRecords, setTotalRecords] = useState(0);
    const [showPayloadPopup, setShowPayloadPopup] = useState(false);
    const [selectedPayload, setSelectedPayload] = useState([]);
    const [selectedNotificationType, setSelectedNotificationType] = useState("");
    const [isNotificationModalOpen, setIsNotificationModalOpen] = useState(false);
    const pageSize = 2000;

    useEffect(() => {
        if (props.storeIntegerID) {
            fetchAmazonNotifications(0);
        }
    }, [props.storeIntegerID]);
  
  
  const fetchAmazonNotifications = (page = 0, searchText = search) => {

    setIsLoading(true);

    FetchAmazonNotificationLogsService(props.token, {
        page: page + 1,
        pageSize,
        search: searchText,
        integerID: props.storeIntegerID
    }).then((response) => {

        if (response && response.status) {
            setNotificationData(response.notificationList);
            setTotalRecords(response.totalRecords);
        }

        setIsLoading(false);
    });
};

    const columns = [
        // {
        //     Header: "Store Name",
        //     accessor: "storeName",
        //     minWidth: 220,
        // },
        // {
        //     Header: "Seller ID",
        //     accessor: "sellerID",
        //     minWidth: 170,
        // },
        {
            Header: "Asin",
            accessor: "asin",
            minWidth: 170,
        },
        {
            Header: "Notification Type",
            accessor: "notificationType",
            minWidth: 260,
        },
        {
            Header: "Notification Payload",
            accessor: "notificationPayload",
            minWidth: 320,
            Cell: (cellInfo) => {
                const value = cellInfo.value;
                if (!Array.isArray(value) || value.length === 0) {
                    return "-";
                }
                const firstLine = value[0];
                return (
                    <p
                        className="comment-paragraph mb-0"
                        style={{
                            color: "#007bff",
                            cursor: "pointer",
                            fontWeight: 300
                        }}
                        onClick={() => {
                            setSelectedPayload(value);
                            setSelectedNotificationType(
                                cellInfo.original.notificationType
                            );
                            setShowPayloadPopup(true);
                        }}
                    >
                        <b>{firstLine.label}:</b>{" "}
                        {String(firstLine.value)}
                    </p>
                );
            }
        },
        {
          Header: "Event Time",
          accessor: "eventTime",
          minWidth: 180,
          Cell: ({ value }) => {
            if (!value) return "-";

            return value
                .replace("T", " ")
                .replace("Z", "")
                .replace(/(\.\d{2})\d*/, "$1");
          }
      }
    ];

    return (
        <div>
        {/* <div className="proactive-monitoring-page"> */}

            {/* <Row className="mt-3 mb-3">
                <Col>
                    <Card className="mb-2">
                        <CardTitle className="rounded mb-0 p-2 amazon-status-title d-flex align-items-center">

                            <button
                                className="back-button-header"
                                onClick={props.onBackHeader}
                                style={{
                                    padding: 0,
                                    border: "none",
                                    background: "transparent",
                                }}
                            >
                                <img src={BackButton} alt="Back" />
                            </button>

                            <div className="flex-grow-1 text-center">
                                Amazon Notifications
                            </div>

                        </CardTitle>
                    </Card>
                </Col>
            </Row> */}

            <Row className="mb-2 align-items-center">
                <Col md={6}>
                    <input
                        type="text"
                        className="form-control w-50"
                        placeholder="Search Amazon Notifications..."
                        value={search}
                        onChange={(e) => {
                            const value = e.target.value;
                            setSearch(value);
                            setCurrentPage(0);
                            fetchAmazonNotifications(0, value);
                        }}
                    />
                </Col>
                <Col md={6} className="d-flex justify-content-end">
                    <Button
                        className="btn-icon btn-icon-left btn-background-color mr-3"
                        style={{ fontWeight: 600 }}
                        onClick={() => setIsNotificationModalOpen(true)}
                        >
                        Subscriptions 
                    </Button>
                    <GridPagination
                        pageSize={pageSize}
                        totalRecords={totalRecords}
                        currentPageProp={currentPage}
                        onPageChange={({ currentPage }) => {
                            setCurrentPage(currentPage);
                            fetchAmazonNotifications(currentPage);
                        }}
                    />
                </Col>
            </Row>

            <Row>
            <Col md={12}>
                <LoadingOverlay
                    active={isLoading}
                    spinner={<Loader active type="ball-pulse" />}
                    text="Loading Amazon Notifications..."
                    styles={{
                        overlay: (base) => ({
                            ...base,
                            background: "#f1f4f6",
                            opacity: 1,
                        }),
                        content: (base) => ({
                            ...base,
                            color: "#000",
                        }),
                    }}
                >
                    <ReactTable
                        data={notificationData}
                        columns={columns}
                        className="-fixed -highlight -striped"
                        getTheadProps={() => ({
                            style: {
                                overflowY: "hidden",
                                background: "#B1FA63",
                                color: "#243837",
                            },
                        })}
                        defaultPageSize={12}
                        noDataText="No Data Found."
                    />
                </LoadingOverlay>
            </Col>
        </Row>
        <NotificationPayload
                isOpen={showPayloadPopup}
                toggle={() => setShowPayloadPopup(false)}
                selectedPayload={selectedPayload}
                notificationType={selectedNotificationType}
            />
            <CustomModal
                header={
                    <>
                        <b>{props.storeName}</b> : Subscriptions
                    </>
                }
                isOpen={isNotificationModalOpen}
                toggle={() => setIsNotificationModalOpen(false)}
                size="lg"
                className="curve-popup"
                footer={
                    <>
                        <Button
                            color="link"
                            onClick={() => setIsNotificationModalOpen(false)}
                        >
                            Cancel
                        </Button>
                    </>
                }
            >
                <NotificationsSubscriptionsTypes
                    token={props.token}
                    storeIntegerID={props.storeIntegerID}
                    storeAccountID={props.storeAccountID}
                />
            </CustomModal>
        </div>
    );
}

const mapStateToProps = state => ({
  token: state.loggedUser.token,
});

export default connect(mapStateToProps)(AmazonNotificationsMainPage);